var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGracious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61,12H47.822C47.319,7.882,45.7,4,43,4c-1.681,0-2.943,1.514-3.779,3.65a3.969,3.969,0,0,0-6.442,0C31.943,5.514,30.681,4,29,4c-2.695,0-4.319,3.882-4.822,8H11a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1h1v6H10V29a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1V51a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V50l2.927,0c.485.054,5.68,1.079,10.264,1.984C32.215,53.763,33.489,54,33.771,54H59a3,3,0,0,0,3-3V49a3,3,0,0,0-2-2.816V24h1a1,1,0,0,0,1-1V13A1,1,0,0,0,61,12ZM8,31V50H4V30H8ZM43,6c.9,0,2.3,2.078,2.81,6H40.19C40.7,8.078,42.1,6,43,6Zm.447,36.1a1.064,1.064,0,0,0-.16-.063L41,41.356V24H58V46H46V45C46,43.5,44.046,42.405,43.447,42.105ZM36,8a2,2,0,1,1-2,2A2,2,0,0,1,36,8Zm-4,6h8v8H32Zm7,10V40.756l-5.5-1.65c-.124-.109-.3-.264-.5-.439V24ZM29,6c.9,0,2.3,2.078,2.81,6H26.19C26.7,8.078,28.1,6,29,6ZM12,14H30v8H12ZM31,24V36.994C27.573,34.226,21.733,30,18,30H14V24ZM60,51a1,1,0,0,1-1,1L33.844,52c-.486-.054-5.681-1.079-10.265-1.984C14.556,48.237,13.281,48,13,48H10V32h8c3.784,0,11.628,6.312,14.331,8.743a1,1,0,0,0,.382.215l9.911,2.974A4.054,4.054,0,0,1,44,45v2a1,1,0,0,1-.918,1l-9.727-1.946L26.5,42.132a1,1,0,1,0-.992,1.736l7,4a.955.955,0,0,0,.3.112l10,2A1,1,0,0,0,43,50a3.006,3.006,0,0,0,2.829-2H59a1,1,0,0,1,1,1Zm0-29H42V14H60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGracious);
export default __webpack_public_path__ + "static/media/gracious.f74fff08f19bce138a63c59d53d0eeab.svg";
export { ForwardRef as ReactComponent };